import React from 'react';
interface FormFieldProps {
  label: string;
  helpText?: string;
  children: React.ReactNode;
  className?: string;
  required?: boolean;
}
export function FormField({
  label,
  helpText,
  children,
  className = '',
  required
}: FormFieldProps) {
  return <div className={`flex flex-col gap-1.5 ${className}`} data-id="element-62">
      <label className="text-sm font-semibold text-gray-700" data-id="element-63">
        {label}
        {required && <span className="text-red-500 ml-1" data-id="element-64">*</span>}
      </label>
      {children}
      {helpText && <p className="text-sm text-gray-500 mt-0.5" data-id="element-65">{helpText}</p>}
    </div>;
}